import React from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import Header from '../Components/Header/HeaderSmall';
import ContactCareGuidePhone from 'material-ui/svg-icons/communication/phone';
import ContactCareGuideEmail from 'material-ui/svg-icons/communication/email';
import RaisedButton from 'material-ui/RaisedButton';
import { createNewMessage } from '../actions/messageActions';
import { resourceApi } from '../utils/fetchUtil';
import { hashHistory } from 'react-router/lib';
import Chat from 'material-ui/svg-icons/communication/forum';
import TabStrip  from '../Components/TabStrip';
import { fireInAppBrowserPlugin } from '../actions/environmentActions';

class CareGuide extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
            careGuide: null,
            careGuideContent: null
        };

        this.loadCareGuide = this.loadCareGuide.bind(this);
    }

    newMessage = () => {
        this.fire('chat');
        this.props.clearMessage();
        hashHistory.push('/message/0/view');
    }

    fire(actionType){   
        let config = {
            method: 'get',
            url: `log/careGuideContact/${actionType}`
        };

        resourceApi(config);  
    }

    componentDidMount() {
        this.loadCareGuide();
    }

    loadCareGuide() {
        var self = this;

        self.setState({fetching: true});

        let config = {
            method: 'get',
            url: `member/careguide`
        };

        resourceApi(config) 
        .then(function (response) {
            self.setState({ careGuideContent: response.data });
        });
    }


    careGuideFirstName(name) {
        return name.split(' ')[0];
    }

    getContent() {
        return {__html: this.state.careGuideContent.PageContent};
    }

    
    render() {

    return (
        <div>
            {(this.state.careGuideContent) && (
               <div>
                    <Header title={"My Care Guide"}  />
                    <div className="container trueno" style={{marginTop: 20}}>
                        <Paper>
                            <div className="container truenoLight" >
                                <h3 style={{textAlign: 'center'}}>{this.state.careGuideContent.PageTitle}</h3>
                                <div className="container">
                                    <div className="care-guide" />
                                  
                                    <div style={{display:"flex", flexDirection:"column", width:"100%"}}>
                                        {this.props.member.IsTwoWayMessagingActive && (
                                            <div style={{textAlign:'center'}}>
                                                <p style={{fontSize: 20, fontWeight: 'bold' }} className="trueno">Start a Conversation Now</p>
                                                <RaisedButton style={{width:150}} label="Chat" primary={true} icon={<Chat />}  onClick={this.newMessage} />
                                            </div>
                                        )}
                                        {this.state.careGuideContent.PageContent && (
                                            <div style={{flexBasis:"100%",  width:"90%", margin:"10px auto 5px"}} dangerouslySetInnerHTML={this.getContent()} />
                                        )}
                                        {/* {!this.state.careGuideContent.PageContent && (
                                            <br />
                                        )} */}
                                        {this.props.member.CareGuideNumber && (
                                            <div style={{textAlign:'center'}}>
                                                <a style={{ textDecoration:"none"}} onClick={() => {this.fire('phone'); fireInAppBrowserPlugin("tel:" + this.props.member.CareGuideNumber)}} >
                                                    <RaisedButton style={{width:150}} icon={<ContactCareGuidePhone />}  primary={true} label="Call"  />
                                                </a>
                                            </div>
                                            )}
                                    </div>
                                   
                                    {this.props.member.CareGuideEmail && (
                                        <a style={{ textDecoration:"none"}} onClick={() => {this.fire('email'); fireInAppBrowserPlugin("mailto:" + this.props.member.CareGuideEmail)}} >
                                            <RaisedButton style={{width:200}} icon={<ContactCareGuideEmail />}  primary={true} label="Email" />
                                        </a>
                                    )}
                                    {/* <CareGuideContact cgContent={this.state.careGuideContent.PageContent} /> */}
                                    <br />
                                </div>
                                
                                <br />
                                <br />
                            </div>
                        </Paper>
                    </div>
                    <TabStrip />
                </div>
            )}
            <br />
            <br />
            <br />
            <br />
            <br />
        </div>
    );
  }
};

//export default MyBenefits;

const mapDispatchToProps = (dispatch) => {
  return {
    clearMessage: () => {
        dispatch(createNewMessage())
      }
  }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuide)



// WEBPACK FOOTER //
// ./src/Pages/CareGuide.js